import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qfkxwwvkpkpzfciqycvi.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFma3h3d3ZrcGtwemZjaXF5Y3ZpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIxNzU0MzksImV4cCI6MjA5Nzc1MTQzOX0.Veh28n0XsoMMPPs8d56vTD1Rp1APrsnms4qTUufZmVU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
